import type { InferResponseTypeFromUrl } from 'api-v4-types'
import type { StreambotComponentProps } from '../types'
import type { MilestoneItem, MilestonesWidgetSettings } from './milestonesWidgetSettingsSchema'
import type { Maybe } from '@/types'
import type { GifAndSoundProps } from '@/components/GifAndSound/GifAndSound'

export type DemoDonationAmount = Pick<
  InferResponseTypeFromUrl<'get', '/fundraising_events/1'>,
  'donated_amount_in_cents'
>

export type MilestonesWidgetProps = StreambotComponentProps<MilestonesWidgetSettings, MilestoneItem[]> & {
  previewDonationData?: DemoDonationAmount
}

export const MilestoneDisplayMode = {
  MilestoneAndAlert: 'MILESTONE_AND_ALERT',
  AlertOnly: 'ALERT_ONLY',
} as const

export type MilestoneDisplayMode = (typeof MilestoneDisplayMode)[keyof typeof MilestoneDisplayMode]

// We make the id nullable, because we depend on the change from null to actual id
// when triggering the gif and sound
export type MilestoneProps = Omit<MilestoneItem, 'id'> &
  Omit<MilestonesWidgetProps, 'darkMode' | 'fundraisingEventId' | 'milestones' | 'mode'> & {
    volume: number
    id: Maybe<string>
    skipPlayback?: boolean
    showMilestoneDetails?: boolean
    lastMilestoneReached?: boolean
  } & Pick<GifAndSoundProps, 'onPlaybackComplete' | 'onPlaybackStart'>

export type MilestoneDetailsProps = Pick<
  MilestonesWidgetProps,
  | 'dataFont'
  | 'dataFontColor'
  | 'dataFontSize'
  | 'dataFontWeight'
  | 'headlineFont'
  | 'headlineFontColor'
  | 'headlineFontSize'
  | 'headlineFontWeight'
> &
  Pick<MilestoneItem, 'amountInCents'> & { lastMilestoneReached?: boolean }
